import { NumberLiteralType } from "typescript";

/* SECTION Standard interfaces */
export type Test = {
    name: string;
    address: string;
    tokenId: string;
    owner: string;
    listingType: number;
    price: number;
    currency: string;
    imgUrls: string[];
    metaverse: string;
    posX: number;
    posY: number;
    views: number;
    likes: number;
    isProperty: true;
    rentalInfo?: IRentalDescriptor;
};
export type IPropertyNFTDescriptor = {
    id: string;
    listing: {
        id: string;
        token_id: string;
        walletAddress: string;
        contract_address: string;
        token_standard: string;
        property: {
            name: string;
            author: string;
            location: string;
            description: string;
            images: {
                platform: string[];
                blockchain: string;
            };
        };
        auction: {
            for_auction: boolean;
            starting_price: number;
            ending_price: number;
        };
        fixed_price: {
            for_fixed_price: boolean;
            price: number;
        };
        collection: {
            id: string;
            is_collection: boolean;
            name: string;
            picture: string[];
            description: string;
        };
        rental: IRentalDescriptor;
        metaverse: string;
        total_number_for_sale: number;
        start_date: number;
        is_internally_listed: boolean;
        listing_expiration_date: Date;
        currency: string;
        type: string;
        views: number;
        likes: number;
        is_private: boolean;
        private_wallet_address: string;
        private_email_address: string;
    };
};

export type INFTDescriptor = {
    address: string;
    tokenId: string;
};

export type IRentalDescriptor = {
    for_rent: boolean;
    is_rented: boolean;
    price: number;
    rental_frequency: string;
    frequency: number;
    expiration_date: number;
    accept_nft_collatoral: boolean;
    collatoral: string[];
    renter: string;
    tenant: string;
    landlord: string;
};
/* !SECTION Standard interfaces */

/* SECTION Platform constants */
// NOTE: keep up to date with ReNFT.sol
export const RENTAL_CONTRACT_SECONDS_PER_INTERVAL = 86400;
export const SEC_IN_A_DAY = 86400;

export const LISTING_TYPE = {
    FOR_SALE: 4047_100,
    FOR_RENT: 4047_200,
    FOR_AUCTION_ENGLISH: 4047_300,
    FOR_AUCTION_DUTCH: 4047_400,
    UNLISTED: 4047_000,
};
/* !SECTION Platform constants */

/* SECTION Property helper functions */
export async function getPropertyMetadataForNFT(nft: INFTDescriptor) {
    // TODO: grab from Moralis or custom metadata server
    // need to populate a full IPropertyNFTDescriptor

    return nft;
}

export function genUIDForNFT(nft: INFTDescriptor) {
    return `${nft.address}-${nft.tokenId}`;
}

// export function getNextRentalPeriodEnd(curTime: Date, rentalInfo: IRentalDescriptor) {
//     const curTimeSec = Math.floor(curTime.getTime());
//     const rentalStartSec = rentalInfo.rentalStartSec;
//     const rentalPeriodSec = rentalInfo.rentalPeriodSec;

//     const rentalPeriodsElapsed = Math.floor((curTimeSec - rentalStartSec) / rentalPeriodSec);
//     const nextRentalPeriodEndSec = rentalStartSec + (rentalPeriodsElapsed + 1) * rentalPeriodSec;
//     return new Date(nextRentalPeriodEndSec * 1000);
// }
/* !SECTION Property helper functions */